import HttpClient from "./HttpClient";

export default class Attachment {
    constructor(attachment) {
        if (!attachment) return;
        this.id = attachment.id;
        this.table_name = attachment.table_name;
        this.table_id = attachment.table_id;
        this.attachment_type = attachment.attachment_type;
        this.location = attachment.location;
        this.created_at = attachment.created_at;
        this.updated_at = attachment.updated_at;
        this.file_name = attachment.file_name;
    }

    static async uploadFile(table_id, table_name, file) {
        const client = new HttpClient();
        let formData = new FormData();
        formData.append("attachment_file", file);
        formData.append("table_id", table_id);
        formData.append("table_name", table_name);
        await client.instance.post("attachments", formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }

    static async uploadFiles(table_id, table_name, files) {
        const client = new HttpClient();
        for (const file of files) {
            let formData = new FormData();
            formData.append("attachment_file", file);
            formData.append("table_id", table_id);
            formData.append("table_name", table_name);
            await client.instance.post("attachments", formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
        }
    }

    async remove() {
        const client = new HttpClient();
        const response = await client.instance.delete(`attachments/${this.id}`);
        return response.data;
    }
}